import { getShares } from '../api/cloudShare';
export default async (shareUid, logger) => {
    return getShares(`/${shareUid}`, {}, logger);
};
